import { STATUS_TYPE } from '../../../enum';

export interface FindContactForm {
  type?: string;
  search?: string;
  limit?: number;
  skip?: number;
}

export interface ContactForm {
  id: string;
  title: string;
  description: string;
  photoUrl: string;
  type: string;
  activeState: boolean;
  createdByUserDetails: {
    id: string
    firstName: string
    lastName: string
    countryCallingCode: string
    mobileNumber: string;
  }
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: ContactForm[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
